import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../utils/BodyWrap";
import ContentDiv from "../utils/ContentDiv";
import GeneralLoader from "../GeneralLoader";
import TrainingMenuItem from "../training/TrainingMenuItem";

// State
import { getTranslations } from "../../store/actions/translations";

class Training extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["training_menu"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		let resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	componentWillMount() {
		// Regardless, we will want to go grab updated reviews info since this won't be loaded in SSR
		// Reviews.userActions(null, this.props);

		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			Training.initialAction(null, this.props);
		}
	}

	render() {
		const { translationsLoading, translations } = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[this.props.translationKey]) {
			if (title !== "") title += " | ";
			title += translations.pages[this.props.translationKey].title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						<div className="section-row">
							{translationsLoading ? (
								<GeneralLoader />
							) : !!translations.pages[this.props.translationKey] ? (
								<ContentDiv>
									{translations.pages[this.props.translationKey].content}
								</ContentDiv>
							) : null}
						</div>
						<div className="section-row section-row--block">
							{!translationsLoading && (
								<div className="training-menu">
									<TrainingMenuItem
										link={"/training/videos"}
										icon={"play"}
										title={translations.sections.training_menu.videos_title}
										content={
											translations.sections.training_menu.videos_description
										}
										footer={translations.sections.training_menu.videos_button}
									/>
									<TrainingMenuItem
										link={"/training/surveys"}
										icon={"graph"}
										title={translations.sections.training_menu.surveys_title}
										content={
											translations.sections.training_menu.surveys_description
										}
										footer={translations.sections.training_menu.surveys_button}
									/>
									<TrainingMenuItem
										link={"/training/documents"}
										icon={"documents"}
										title={translations.sections.training_menu.documents_title}
										content={
											translations.sections.training_menu
												.documents_description
										}
										footer={
											translations.sections.training_menu.documents_button
										}
									/>
									<TrainingMenuItem
										link={"/training/education"}
										icon={"laptop"}
										title={translations.sections.training_menu.education_title}
										content={
											translations.sections.training_menu
												.education_description
										}
										footer={
											translations.sections.training_menu.education_button
										}
									/>
								</div>
							)}
						</div>
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations }
)(Training);



// WEBPACK FOOTER //
// ./src/components/training/Training.js